import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from 'src/app/core/services/i18n.service';

@Pipe({ name: 'localeCurrency', pure: false, standalone: false })
export class LocaleCurrencyPipe implements PipeTransform {
  constructor(private i18n: I18nService) {}

  transform(value: any): string {
    const amount = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(amount)) return String(value ?? '');
    const locale = this.i18n.currentLang === 'es' ? 'es' : 'en-US';
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' }).format(amount);
  }
}
